export default __webpack_public_path__ + "static/media/53902-online-shopping-and-delivery.469f8d12.gif";